// src/components/PreInterviewCard.js

import React from 'react';
import { Paper, Typography, Box, IconButton, Tooltip, Chip } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote'; // İkon güncellendi
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import { isPast, format } from 'date-fns';
import { tr } from 'date-fns/locale';

const getStatusChipColor = (status) => {
    const colors = { 'Yeni': 'info', 'Aranacak': 'secondary', 'Geri Arandı': 'primary' };
    return colors[status] || 'default';
};

const PreInterviewCard = ({ interview, onMenuOpen, onCardClick }) => {
    const isCallbackDue = interview.durum === 'Aranacak' && interview.geriAramaTarihi && isPast(interview.geriAramaTarihi.toDate());

    const formattedDate = interview.geriAramaTarihi 
        ? format(interview.geriAramaTarihi.toDate(), 'dd MMM HH:mm', { locale: tr })
        : null;

    return (
        <Paper 
            onClick={() => onCardClick(interview)}
            sx={{ 
                p: 1.5, 
                mb: 2,
                borderLeft: 5,
                borderColor: isCallbackDue ? 'error.main' : 'transparent',
                cursor: 'pointer',
                '&:hover': {
                    boxShadow: 3,
                    borderColor: isCallbackDue ? 'error.dark' : 'primary.main'
                }
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Box>
                    <Typography variant="body1" fontWeight="bold">{interview.adSoyad}</Typography>
                    <Typography variant="caption" color="text.secondary">{interview.telefon}</Typography>
                </Box>
                <Tooltip title="İşlemler">
                    <IconButton size="small" onClick={(e) => onMenuOpen(e, interview)} sx={{p: 0.5}}>
                        <EditNoteIcon color="primary" />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box sx={{ my: 1 }}>
                <Typography variant="body2">
                    <b>Hizmet:</b> {interview.ilgilenilenHizmet || '-'}
                </Typography>
                {interview.durum === 'Aranacak' && formattedDate && (
                     <Typography variant="body2" color={isCallbackDue ? 'error.main' : 'text.primary'} fontWeight="bold" sx={{display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5}}>
                        <PhoneCallbackIcon fontSize="small" />
                        {formattedDate}
                    </Typography>
                )}
            </Box>
            <Chip label={interview.durum} color={getStatusChipColor(interview.durum)} size="small" />
        </Paper>
    );
};

export default PreInterviewCard;